module.exports = __webpack_public_path__ + "img/green_124.facdec2f.png";